import { createAction, createReducer, on, props } from '@ngrx/store';
import * as GoogleDriveActions from './file-explorer.actions';

export const fileExplorerFeatureKey = 'fileExplorer';

export interface DriveState {
  fileList: any;
  loading: boolean,
  submitButtonLoading: boolean,
  activeProvider: string | null,
  folderOrder: any,
  connectedAccount: any;
  connectedAccountList: any;
  error: {
    timestamp?: number;
    key?: string;
    error?: unknown;
  };
}

export const initialState: DriveState = {
  fileList: null,
  activeProvider: null,
  loading: false,
  submitButtonLoading: false,
  folderOrder: [],
  connectedAccount: null,
  connectedAccountList: [],
  error: {}
};

export const reducer = createReducer(
  initialState,
  on(GoogleDriveActions.ConnectFileExplorer, (state, action) => ({
    ...state,
    loading: true,
    activeProvider: action.payload.provider,
    alertVisible: false
  })),
  on(GoogleDriveActions.ConnectFileExplorerSuccessful, (state) => ({
    ...state,
    loading: false
  })),
  on(GoogleDriveActions.ConnectFileExplorerFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload.error
  })),
  on(GoogleDriveActions.GetFileExplorerFileList, (state) => ({
    ...state,
    loading: true
  })),
  on(GoogleDriveActions.GetFileExplorerFileListSuccessful, (state, action) => ({
    ...state,
    fileList: action.payload.files,
    loading: false
  })),
  on(GoogleDriveActions.GetFileExplorerFileListFailure, (state) => ({
    ...state,
    loading: false
  })),
  on(GoogleDriveActions.OrderFileExplorer, (state, action) => {
    let root;
    if (!state.folderOrder?.length) {
      root = { id: action.payload.folder?.parentId, name: 'root' }
    }
    let folderOrder = !state.folderOrder?.length ? [root] : state.folderOrder;
    folderOrder = [
      ...folderOrder,
      action.payload.folder
    ];
    const index = folderOrder.findIndex(item => item.id === action.payload.folder?.id);

    if (index !== -1) {
      folderOrder = folderOrder.slice(0, index + 1);
    }
    return {
      ...state,
      folderOrder
    }
  }),
  on(GoogleDriveActions.OrderFileExplorerReset, (state) => ({
    ...state,
    folderOrder: []
  })),
  on(GoogleDriveActions.IngestMultipleFilesExplorer, (state) => ({
    ...state,
    submitButtonLoading: true
  })),
  on(GoogleDriveActions.IngestMultipleFilesExplorerSuccessful, (state) => ({
    ...state,
    submitButtonLoading: false
  })),
  on(GoogleDriveActions.IngestMultipleFilesExplorerFailure, (state) => ({
    ...state,
    submitButtonLoading: false
  })),
  on(GoogleDriveActions.GetConnectedAccount, (state) => ({
    ...state,
    connectedAccountLoading: true
  })),
  on(GoogleDriveActions.GetConnectedAccountSuccessful, (state, action) => ({
    ...state,
    connectedAccount: action.payload.connectedAccount,
    connectedAccountLoading: false,
    alertVisible: true
  })),
  on(GoogleDriveActions.UpdateConnectedAccountByIdSuccessful, (state, action) => ({
    ...state,
    connectedAccount: {
      ...state.connectedAccount,
      isFileAccessShared: action.payload.isFileAccessShared
    }
  })),
  on(GoogleDriveActions.GetConnectedAccountFailure, (state) => ({
    ...state,
    connectedAccount: {},
    connectedAccountLoading: false,
    alertVisible: true
  })),
  on(GoogleDriveActions.DeleteConnectedAccountByProvider, (state) => ({
    ...state,
    connectedAccountLoading: true,
  })),
  on(GoogleDriveActions.DeleteConnectedAccountByProviderSuccessful, (state) => ({
    ...state,
    connectedAccount: {},
    connectedAccountLoading: false,
  })),
  on(GoogleDriveActions.DeleteConnectedAccountByProviderFailure, (state) => ({
    ...state,
    connectedAccountLoading: false,
  })),
  on(GoogleDriveActions.ResetDrive, (state) => ({
    ...initialState,
    activeProvider: state.activeProvider
  })),
  on(GoogleDriveActions.GetConnectedAccountListSuccessful, (state, action) => ({
    ...state,
    connectedAccountList: [...state?.connectedAccountList, action.payload.connectedAccount]
  })),
  on(GoogleDriveActions.CheckFileViewPermisson, (state) => ({
    ...state,
    submitButtonLoading: true
  })),
  on(GoogleDriveActions.CheckFileViewPermissonSuccessful, (state) => ({
    ...state,
    submitButtonLoading: false
  })),
  on(GoogleDriveActions.CheckFileViewPermissonFailure, (state) => ({
    ...state,
    submitButtonLoading: false
  }))
);
